var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ethereum"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#8D91AB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.498 4V12.87L23.995 16.22L16.498 4Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.498 4L9 16.22L16.498 12.87V4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.498 21.9692V27.9962L24 17.6172L16.498 21.9692Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.498 27.9962V21.9682L9 17.6172L16.498 27.9962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.498 20.574L23.995 16.221L16.498 12.873V20.574Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M9 16.221L16.498 20.574V12.873L9 16.221Z",
    fill: "white",
    fillOpacity: 0.602
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeth);
export default __webpack_public_path__ + "static/media/geth.6fb46d7a69e0a4d4ac3697d18a77a5f8.svg";
export { ForwardRef as ReactComponent };